import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/conditioner"
  }, React.createElement("g", {
    id: "Vector"
  }, React.createElement("path", {
    d: "M11.2072 1.50723L9.00002 3.71443V12.2858L11.2072 14.493L9.793 15.9072L8.00006 14.1143L6.20723 15.9072L4.79298 14.493L7.00002 12.2859V3.71436L4.79298 1.50721L6.20723 0.0930348L8.00006 1.88595L9.793 0.0930176L11.2072 1.50723Z",
    fill: "currentColor"
  }), React.createElement("path", {
    d: "M3.98062 1.97622L4.78851 4.9913L12.2116 9.277L15.2266 8.46911L15.7443 10.401L13.2951 11.0572L13.9514 13.5063L12.0195 14.024L11.2116 11.0091L3.78845 6.72332L0.773488 7.53109L0.255897 5.59923L2.70503 4.94305L2.04877 2.49385L3.98062 1.97622Z",
    fill: "currentColor"
  }), React.createElement("path", {
    d: "M0.773498 8.46913L3.78859 9.27702L11.2116 4.99132L12.0195 1.97624L13.9514 2.49388L13.2951 4.94307L15.7442 5.59925L15.2266 7.53112L12.2117 6.72334L4.78852 11.0091L3.9806 14.024L2.04876 13.5063L2.70506 11.0572L0.255859 10.401L0.773498 8.46913Z",
    fill: "currentColor"
  }))));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Conditioner16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Conditioner16 = createIcon(IconComponent);